import {useQuery} from 'react-query'
import {useParams} from 'react-router-dom'

import {VenueService} from '../../services/venue'

export const useVenue = ({refetchOnWindowFocus = false}: {refetchOnWindowFocus?: boolean} = {}) => {
  const {venueId} = useParams<{venueId: string}>()
  return useQuery(
    VenueService.queries.getVenueQuery({
      params: {id: venueId},
      refetchOnWindowFocus,
    }),
  )
}

// The venue a specific record belongs to — NOT the one in the URL. An order opened from another
// venue's context must show ITS venue, not whichever venue the customer happens to be browsing
// (WBA-4607).
export const useVenueById = (venueId?: string) =>
  useQuery({
    ...VenueService.queries.getVenueQuery({params: {id: venueId}}),
    enabled: Boolean(venueId),
  })
